import { KTypeParameterBase70dfo08xyjmg as KTypeParameterBase } from '../../KTypeParameterBase.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KTypeParameterImplClass;
function KTypeParameterImpl() {
  if (KTypeParameterImplClass === VOID) {
    class $ extends KTypeParameterBase() {
      constructor(name, upperBounds, variance, isReified, containerFqName) {
        super();
        this.name_1 = name;
        this.upperBounds_1 = upperBounds;
        this.variance_1 = variance;
        this.isReified_1 = isReified;
        this.containerFqName_1 = containerFqName;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      get_variance_ik7ku2_k$() {
        return this.variance_1;
      }
      get_containerFqName_uox1ci_k$() {
        return this.containerFqName_1;
      }
    }
    initMetadataForClass($, 'KTypeParameterImpl');
    KTypeParameterImplClass = $;
  }
  return KTypeParameterImplClass;
}
//region block: exports
export {
  KTypeParameterImpl as KTypeParameterImpl2de0szhlrzcmf,
};
//endregion

//# sourceMappingURL=KTypeParameterImpl.mjs.map
